export default {
  NOTE: 'note',
}



// WEBPACK FOOTER //
// ./src/app/Types.js